export default __webpack_public_path__ + "static/natural-cork-0aff995d5771bb85259cad8344a6ff0e.png";